import React from 'react';

const CompanyIntroduction = () => {
  return (
    <section id="frame1" className="bg-background py-20 md:py-28">
      <div className="container mx-auto px-4">
        <div className="text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-[36px] font-semibold text-foreground mb-4 sm:mb-6 leading-[1.3] px-4">
            <span className="text-accent">Mahatva Engineering<sup>®</sup></span> Since 2025
          </h2>
          <p className="max-w-4xl mx-auto text-muted-foreground text-base sm:text-lg leading-relaxed px-4">
            Mahatva Engineering offer the widest range of standard mechanical seals. We are the seal manufacturer most likely to have avaiable what you need ex-stock. We can supply the vast majority of global seal requiements from stock. Mahatva Engineering are leading providers of volume standard Mechanical Seals for O.E.M pump manufacturers, Alfa Laval, A.P.V, A.B.S, Allweiler, Fristam, Hilge, Inoxpa, Lowara, Grundfos, KSB, Flygt, Tsurumi...
          </p>
        </div>
      </div>
    </section>
  );
};

export default CompanyIntroduction;

